import { Progress } from '@/components/ui/progress';
import { cn } from '@/lib/utils';
import {
  formatCompactTokens,
  formatQuotaDate,
  getQuotaProgressPercent,
  getQuotaProgressTone,
} from '../quota-format';

type QuotaMiniProgressProps = {
  consumed: number;
  extraTokens?: number;
  renewsAt?: string | null;
  tokenLimit: number;
  showRenewal?: boolean;
  className?: string;
};

export function QuotaMiniProgress({
  className,
  consumed,
  extraTokens = 0,
  renewsAt,
  showRenewal = true,
  tokenLimit,
}: QuotaMiniProgressProps) {
  const allowance = tokenLimit + extraTokens;
  const ratio = allowance > 0 ? consumed / allowance : 0;
  const tone = getQuotaProgressTone(ratio, consumed >= allowance);

  return (
    <div className={cn('min-w-[10rem] space-y-1.5', className)}>
      <div className="flex items-center justify-between gap-2 text-xs text-muted-foreground">
        <span>{formatCompactTokens(consumed)} / {formatCompactTokens(allowance)}</span>
      </div>
      <Progress
        value={getQuotaProgressPercent(consumed, allowance)}
        className={cn(
          'h-2',
          tone === 'success' && '[&_[data-slot=progress-indicator]]:bg-emerald-500',
          tone === 'warning' && '[&_[data-slot=progress-indicator]]:bg-orange-500',
          tone === 'danger' && '[&_[data-slot=progress-indicator]]:bg-destructive',
        )}
      />
      {showRenewal && renewsAt ? (
        <p className="text-xs text-muted-foreground">
          Renouvellement le {formatQuotaDate(renewsAt)}
        </p>
      ) : null}
    </div>
  );
}
